export function renderDoughnutChart({
     canvasId,
     title,
     labels,
     data,
     primaryColor = '#429745',
     secondaryColor = '#FF6347'
 }) {
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;

    const ctx = canvas.getContext('2d');

    new Chart(ctx, {
        type: 'doughnut',
        data: {
            labels: labels,
            datasets: [{
                label: title,
                data: data,
                backgroundColor: [primaryColor, secondaryColor],
                borderWidth: 1
            }]
        },
        options: {
            layout: {
                padding: 5,
            },
            responsive: true,
            cutout: '80%',
            plugins: {
                legend: {
                    display: false,
                    position: 'top',
                    align: 'start',
                    labels: {
                        boxWidth: 20,
                        padding: 10,
                        usePointStyle: true
                    }
                },
                title: {
                    display: true,
                    text: title
                },
                tooltip: {
                    callbacks: {
                        label: function (tooltipItem) {
                            return tooltipItem.label + ': ' + tooltipItem.raw + '%';
                        }
                    }
                }
            }
        }
    });
}

// Make sure these are globally accessible if used in Blade <script>
window.renderDoughnutChart = renderDoughnutChart;
